import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ResourcesService } from '../../../../services/resources/resources.service';

// Historial de Registro de Horarios, botón "Historial" (change 2026-10-correcciones-campania-2, punto 5).
// Usa los mismos filtros de la pantalla: fechas de los fichajes y cuadrillas seleccionadas.
@Component({
  selector: 'modal-historial-rh',
  styleUrls: [('./modalHistorialRH.scss')],
  templateUrl: './modalHistorialRH.html'
})

export class ModalHistorialRH {
  cabecillas: string[] = [];
  desde: string = null;
  hasta: string = null;
  filas = [];
  loading = true;
  error = '';

  private etiquetas = { fecha: 'Fecha', hora: 'Hora', tipo_registro: 'Tipo', cant_fotos: 'Fotos' };

  constructor(
    private activeModal: NgbActiveModal,
    private _resourcesService: ResourcesService) {
  }

  ngOnInit() {
    this._resourcesService.getHistorialRH(this.cabecillas, this.desde, this.hasta)
      .subscribe(
      (result) => { this.filas = result; this.loading = false; },
      (error) => { this.error = 'No se pudo leer el historial.'; this.loading = false; }
      );
  }

  public closeModal() {
    this.activeModal.close();
  }

  public filtro(): string {
    const fechas = this.desde || this.hasta ? `Fichajes del ${this.desde || '…'} al ${this.hasta || '…'}` : 'Todas las fechas';
    const cuadrillas = this.cabecillas.length ? `cuadrillas ${this.cabecillas.join(', ')}` : 'todas las cuadrillas';
    return `${fechas}, ${cuadrillas}`;
  }

  public fecha(texto: string): string {
    return texto && texto.length === 8 ? `${texto.substr(6, 2)}/${texto.substr(4, 2)}/${texto.substr(0, 4)}` : (texto || '');
  }

  public hora(texto: string): string {
    return texto && texto.length >= 4 ? `${texto.substr(0, 2)}:${texto.substr(2, 2)}` : (texto || '');
  }

  // Fichaje completo (Nuevo Registro y Eliminar): fecha, hora y tipo
  public fichaje(datos): string {
    return datos ? `${this.fecha(datos.fecha)} ${this.hora(datos.hora)} ${datos.tipo_registro || ''}` : '';
  }

  // Editar: un renglón por campo cambiado, "Campo: antes → después"
  public cambios(fila): string[] {
    return Object.keys(fila.despues || {}).map(campo => {
      const formato = (v) => campo === 'fecha' ? this.fecha(v) : campo === 'hora' ? this.hora(v) : (v === null ? '—' : v);
      return `${this.etiquetas[campo] || campo}: ${formato(fila.antes[campo])} → ${formato(fila.despues[campo])}`;
    });
  }

  public rangoFechas(fila): string {
    if (!fila.fecha_desde) return '';
    return fila.fecha_desde === fila.fecha_hasta ? this.fecha(fila.fecha_desde)
      : `${this.fecha(fila.fecha_desde)} al ${this.fecha(fila.fecha_hasta)}`;
  }
}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalHistorialRH/modalHistorialRH.component.ts